<template lang="pug">
b-modal#modal-scenario-popup-copy(title='ポップアップをコピーします。')
  .row
    .form-group.col-12
      .alert.alert-danger(v-if="errorMessage")
        | {{ errorMessage }}
      label ポップアップ名
      input(type="text",class="form-control",:value="$store.state.scenario_popup.name",@input="updateName($event)")
  template(v-slot:modal-footer)
    b-button(variant="default",@click="copy($event)",:disabled="isProcessing") {{ buttonText }}
</template>

<script>
  import Vue from 'vue'

  export default {
    props: {
      redirect_url: String
    },
    data() {
      return {
        isProcessing: false,
        errorMessage: ''
      }
    },
    computed: {
      buttonText() {
        return this.isProcessing ? '複製中です...' : '複製する'
      }
    },
    methods: {
      async copy(e){
        e.preventDefault()
        this.errorMessage = ''
        this.isProcessing = true
        try {
          await this.$store.dispatch("scenario_popup/copy")
          location.href = this.redirect_url
        } catch (error) {
          this.isProcessing = false
          const responseMessage = error?.response?.data?.message
          const responseError = error?.response?.data?.error
          const fallbackMessage = 'コピーに失敗しました。時間をおいて再度お試しください。'
          this.errorMessage = responseMessage || responseError || fallbackMessage
          console.error(error)
        }
      },
      updateName(e){
        e.preventDefault()
        this.$store.commit("scenario_popup/setName", e.target.value)
      }
    },
    components: {
    },
    async mounted(){
      await Vue.nextTick()
    },
  }
</script>
<style lang="scss" scoped>
</style>
